module.exports = __webpack_public_path__ + "assets/videos/wuhan_zoomin-desktop.mp4?v=ddd01f0a";